import { render, staticRenderFns } from "./ResidencePage.vue?vue&type=template&id=88a3b72a&"
import script from "./ResidencePage.vue?vue&type=script&lang=js&"
export * from "./ResidencePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88a3b72a')) {
      api.createRecord('88a3b72a', component.options)
    } else {
      api.reload('88a3b72a', component.options)
    }
    module.hot.accept("./ResidencePage.vue?vue&type=template&id=88a3b72a&", function () {
      api.rerender('88a3b72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ResidencePage.vue"
export default component.exports